import { useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";

const numberRegex = /^\d*$/;

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

const emptyItem = {
  sadrzaj: "",
  kom: ""
};

function ButtonsAddItem({ setCurrentState, setNewData }) {
  const [newItem, setNewItem] = useState(emptyItem);

  const { dictionary } = useGlobalContext();

  const handleChangeInput = (value, key) => {
    if (key === "kom" && !numberRegex.test(value)) return;
    setNewItem((prev) => ({ ...prev, [key]: value }));
  };

  const handleSacuvaj = () => {
    const novaStavka = {
      ...newItem,
      kom: Number(newItem.kom),
      custom: true,
      id: Math.random()
    };

    setNewData((prev) => ({
      ...prev,
      stavke: [...prev.stavke, novaStavka]
    }));
    setCurrentState("EDIT");
  };

  const handleOdustani = () => {
    setCurrentState("EDIT");
  };

  const isDisabledSacuvaj =
    !newItem.kom || newItem.kom === "0" || !newItem.sadrzaj;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "15px"
      }}
    >
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
        <div style={{ width: "90%" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["nazivStavkeKojuDodajete"]}
          </div>
          <input
            value={newItem.sadrzaj}
            onChange={(e) => handleChangeInput(e.target.value, "sadrzaj")}
            style={{
              height: "40px",
              padding: "10px",
              fontSize: "16px",
              width: "100%"
            }}
          />
        </div>

        <div style={{ width: "10%" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["komada"]}
          </div>
          <input
            value={newItem.kom}
            onChange={(e) => handleChangeInput(e.target.value, "kom")}
            style={{
              height: "40px",
              padding: "10px",
              fontSize: "16px",
              width: "100%"
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "flex-end"
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div
          onClick={handleSacuvaj}
          style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            {dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ButtonsAddItem;
